import React from 'react'
import { styled, SxProps } from '@mui/material'
import { muiColors } from '@zuto/theme/src/mui/DefaultTheme'

type CardProps = {
  children: React.ReactNode
  testId?: string
  styleOverrides?: SxProps
}

const MuiCardContainer = styled('div')({
  backgroundColor: muiColors.prominentColors.lightBlue,
  borderRadius: '12px'
})

const Card = ({
  children,
  testId,
  styleOverrides
}: CardProps): JSX.Element => (
  <MuiCardContainer sx={{ p: 5, ...styleOverrides }} data-testid={testId}>
    {children}
  </MuiCardContainer>
)

export default Card
